export default () => ({
  items: [],
  query: {
    name: null,
    ref: null,
    thumb: null
  }
})
